/**
 * Created by eliasmj on 11/11/2014.
 */
angular.module('qkr').factory('OutletFormService', (utils) => {
    const root = {};

    root.outlet = {
        addressLine1: '',
        addressLine2: '',
        city: '',
        postalcode: '',
        name: '',
        state: '',
        latitude: '',
        longitude: '',
        timezoneId: ''
    };

    root.customRegionTax = {
        exists: false,
        name: '',
        region: '',
        rate: null
    };

    root.maxLengthName = 30;

    root.clearOutlet = function() {
        root.outlet = {};
    };

    root.changeName = function() {
        const name = root.outlet.addressLine1;

        if (!utils.hasNoValue(name)) {
            return name.substring(0, root.maxLengthName);
        }
    };

    return root;
});



// WEBPACK FOOTER //
// ./src/services/outlet/outlet.form.service.js